import React from 'react';
import '../assets/sass/screenLoading.css';

//{ createContext, useState, useContext } 
const ScreenLoading = () => {
    return (
        <div className='screen-loading'>
            <div className='loading-container'>
                <div className='spinner'>
                </div>
                <p>Loading Please wait....</p>
            </div>
        </div>


    );
};
export default ScreenLoading;



//import { OrbitProgress } from 'react-loading-indicators';

//const LoadingContext = createContext();

// export default function ScreenLoading({ children }) {
//     const [loading, setLoading] = useState(false);

//     const showLoading = () => setLoading(true);
//     const hideLoading = () => setLoading(false);

//     return (
//         <LoadingContext.Provider value={{ loading, showLoading, hideLoading }}>
//             {children}

//             {loading && (
//                 <div style={styles.overlay}>
//                     <div style={styles.loaderBox}>
//                         <OrbitProgress
//                             variant="dotted"
//                             dense
//                             size="medium"
//                             color="#3e91d9"
//                             text="Please wait..."
//                         />
//                     </div>
//                 </div>
//             )}
//         </LoadingContext.Provider>
//     );
// }

// export function useLoading() {
//     return useContext(LoadingContext);
// }

// const styles = {
//     overlay: {
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100vw",
//         height: "100vh",
//         background: "rgba(255,255,255,0.8)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 9999,
//     },
//     loaderBox: {
//         padding: "20px",
//         borderRadius: "10px",
//     },
// };

